import ApiService from "@/common/api.service";
import {
  FETCH_FOLDERS,
  FOLDER_CREATE,
  FOLDER_UPDATE,
  FOLDER_DELETE,
  FOLDER_UNSET_CURRENT,
  FETCH_NOTES,
  NOTE_CREATE
} from "./actions.type";
import {
  SET_FOLDERS,
  SET_CURRENT_FOLDER,
  UNSET_CURRENT_FOLDER,
  ADD_FOLDER,
  SET_NOTES,
  SET_CURRENT_NOTE,
  ADD_NOTE,
  UNSET_NOTES
} from "./mutations.type";

const state = {
  folders: {},
  currentFolder: null,
  currentNote: null,
  notes: {}
};

const getters = {
  folders(state) {
    return state.folders;
  },
  currentFolder(state) {
    return state.currentFolder;
  },
  currentNote(state) {
    return state.currentNote;
  },
  notes(state) {
    return state.notes;
  }
};

const actions = {
  [FETCH_FOLDERS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get("folders/")
        .then(({ data }) => {
          context.commit(SET_FOLDERS, data);
          resolve(data);
        })
    });
  },
  [FOLDER_CREATE](context, folder) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.post("folders/", folder)
        .then(({ data }) => {
          context.commit(ADD_FOLDER, data);
          resolve(data);      
        })
    });
  },
  [FOLDER_UPDATE](context, params) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.update("folders/" + params.folder_slug + "/", params.folderData)
        .then(({ data }) => {
          this.dispatch(FETCH_FOLDERS, null, { root: true });
          // context.commit(SET_CURRENT_FOLDER, data);
          resolve(data);      
        })
    });
  },
  [FOLDER_DELETE](context, folder) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.delete("folders/" + folder + "/")
        .then(({ data }) => {
          // context.commit(REMOVE_FOLDER, data);
          this.dispatch(FETCH_FOLDERS, null, { root: true });
          context.commit(UNSET_NOTES);
          resolve(data);      
        })
    });
  },
  [FOLDER_UNSET_CURRENT](context) {
    context.commit(UNSET_CURRENT_FOLDER);
    // Ridondante, unset_notes resetta già il valore di currentFolder
    // @ToDo slegare le due cose
    context.commit(UNSET_NOTES);
  },
  [FETCH_NOTES](context, folder) {
    return new Promise(resolve => {
      let slug = folder.folder_slug;
      ApiService.setHeader();
      ApiService.get("folders/" + slug + "/notes/")
      .then(({ data }) => {
        context.commit(SET_NOTES, {
          'notes': data,
          'folder': folder
        });
        resolve(data);      
      })
    });
  },
  [NOTE_CREATE](context, params) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.post("folders/" + params.folder.folder_slug + "/notes/", params.note)
      .then(({ data }) => {
        context.commit(ADD_NOTE, data);
        resolve(data);      
      })
    });
  }
}

const mutations = {
  [SET_FOLDERS](state, folders) {
    state.folders = folders;
    state.errors = {};
  },
  [ADD_FOLDER](state, folder) {
    state.folders.push(folder);
  },
  [SET_CURRENT_FOLDER](state, folder) {
    state.currentFolder = folder;
  },
  [UNSET_CURRENT_FOLDER](state) {
    state.currentFolder = null;
  },
  [SET_CURRENT_NOTE](state, note) {
    state.currentNote = note;
  },
  [ADD_NOTE](state, note) {
    state.notes.push(note);
  },
  [SET_NOTES](state, {notes, folder}) {
    state.notes = notes;
    state.currentFolder = folder;
  },
  [UNSET_NOTES](state) {
    state.notes = {};
    state.currentFolder = null;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};